export const GET_WELCOME = "GET_WELCOME";
export const GET_MARCA = "GET_MARCA";
export const GET_STATE_LOADING = "GET_STATE_LOADING";
export const GET_STATE_LOADING_MARCA = "GET_STATE_LOADING_MARCA";